module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-05.27f3052e.png";